import { Box, Typography, Avatar, Grid, useTheme } from "@mui/material";
import Barcode from "react-barcode";
import QRCode from "react-qr-code";

export default function CreativeIDCard({
    data,
    school,
    colors,
    code, fontcolor,
    dark = colors,
}) {
    const items = Array.isArray(data) ? data : [];
    const theme = useTheme();
    return (
        <Box id="emp-id-cards-root">
            <Grid container spacing={2}>
                {items?.map((emp) => (
                    <Box sx={{
                        width: 330,
                        height: 460,
                        bgcolor: "white",
                        borderRadius: 2,
                        overflow: "hidden",
                        boxShadow: 6,
                        position: "relative",
                        fontFamily: "Arial"
                    }} key={emp.id}>

                        {/* TOP HEADER */}
                        <Box sx={{
                            height: 140,
                            bgcolor: colors[emp.id] || theme.palette.primary.main,
                            color: "white",
                            textAlign: "center",
                            pt: 1,
                            fontWeight: 700
                        }}>
                            <Box
                                sx={{
                                    display: "flex",
                                    alignItems: "center",
                                    // bgcolor: "#fff",
                                    bgcolor: colors[emp.id] || theme.palette.primary.main,
                                    // borderBottom: "1px solid #ddd",
                                    p: 0.4,
                                    gap: 1.5,
                                }}
                            >
                                <Avatar
                                    src={school?.logoUrl || null}
                                    alt="School Logo"
                                    sx={{ width: 80, height: 80, borderRadius: 1 }}
                                />
                                <Box sx={{ color: fontcolor || 'white' }}>
                                    <Typography variant="subtitle1" sx={{ fontWeight: 700, lineHeight: 1.5 }}>
                                        {school.schoolName}
                                    </Typography>
                                    <Typography variant="caption" sx={{ display: "block", lineHeight: 1.2 }}>
                                        {[school.addressDTO.addressLine1, school.addressDTO.city, school.addressDTO.pincode, school.addressDTO.state].join(", ")}
                                        | Tel: {school.contactPhone}
                                    </Typography>
                                </Box>
                            </Box>
                        </Box>

                        {/* CURVE STRIPE */}
                        <Box sx={{
                            position: "absolute",
                            top: 110,
                            width: "100%",
                            height: 40,
                            bgcolor: dark,
                            borderTopLeftRadius: "100% 100%",
                            borderTopRightRadius: "100% 100%"
                        }} />

                        {/* PHOTO */}
                        <Box sx={{
                            position: "absolute",
                            top: '20%',
                            width: "100%",
                            display: "flex",
                            justifyContent: "center"
                        }}>
                            <Avatar src={emp.photo || null}
                                sx={{
                                    width: 130,
                                    height: 130,
                                    border: `6px solid ${colors[emp.id] || theme.palette.primary.main}`
                                }} />
                        </Box>

                        {/* DIAGONAL NAME RIBBON */}
                        <Box sx={{
                            mt: 10,
                            px: 1
                        }}>

                            <Box sx={{
                                bgcolor: colors[emp.id] || theme.palette.primary.main,
                                color: fontcolor || "white",
                                display: "inline-block",
                                px: 2,
                                py: 1,
                                transform: "skewX(-20deg)"
                            }}>
                                <Typography sx={{ transform: "skewX(20deg)", fontWeight: 700 }}>
                                    {[emp.firstName, emp.lastName].join(" ")}
                                </Typography>
                            </Box>

                        </Box>

                        {/* ROLE RIGHT BLOCK */}
                        <Box sx={{
                            bgcolor: colors[emp.id] || theme.palette.primary.main,
                            color: fontcolor || "white",
                            width: 180,
                            py: 0.5,
                            px: 2,
                            mt: 0,
                            ml: "auto",
                            mr: 1,
                            transform: "skewX(-20deg)"
                        }}>
                            <Typography sx={{ transform: "skewX(20deg)", fontWeight: 700 }} variant="subtitle2">
                                {emp.experience < 1 ? "" : "Senior"}  {[emp.specialization, "Teacher"].join(" ")}
                            </Typography>
                        </Box>

                        {/* DETAILS */}
                        <Box sx={{ py: 2, px: 3, fontSize: 13 }}>
                            <Typography variant="subtitle2"><b>ID</b> : {emp.employeeCode}</Typography>
                            {/* <Typography variant="subtitle2"><b>Email</b> : {emp.email}</Typography> */}
                            <Typography variant="subtitle2"><b>Phone</b> : {emp.phone}</Typography>
                            {/* <Typography variant="subtitle2"><b>Blood</b> : {emp.blood}</Typography> */}
                            <Typography variant="subtitle2"><b>Address</b> : {emp?.addressDTO?.addressLine1}</Typography>
                        </Box> 

                        {/* QR */}
                        <Box sx={{ position: "absolute", bottom: 10, right: 20 }}>
                            {code === 'QRCode' ? (
                                <QRCode value={[emp.id, emp.employeeCode].join("#")} size={70} />
                            ) : code === 'Barcode' ? (
                                <Barcode width={1} height={60} value={[emp.id, emp.employeeCode].join("#")}
                                // format="CODE128"
                                />
                            ) : null}
                        </Box>

                    </Box>
                ))
                }
            </Grid >
        </Box >
    )
}
